import { Button, useModal } from '@payright/web-components';
import { ModalCancelPlan } from '../modals/ModalCancelPlan';

type ButtonCancelPlanProps = {
  className?: string;
  disabled: boolean;
};

export const ButtonCancelPlan = ({ disabled, className }: ButtonCancelPlanProps) => {
  const { openModal, dismissModal } = useModal();

  return (
    <Button
      className={className}
      maxWidth="100%"
      type="button"
      outline
      colour="blue"
      disabled={disabled}
      handleClick={() => openModal(<ModalCancelPlan handleClose={dismissModal} />)}
    >
      Cancel
    </Button>
  );
};
